export default function isArray (arr) {
  return Array.isArray(arr);
}